module.exports = __webpack_public_path__ + "static/main-fb9fbb4aa72bf77edb76a40c93945e67.png";